import IGeoCoordinate from "./IGeoCoordinate";
import ILeadNote, { ILeadNoteResponseModel } from "./ILeadNote";

export default interface ILead {
    id: number;
    centerPoint: IGeoCoordinate;
    parcelId: string | null;
    address: string | null;
    city: string | null;
    state: string | null;
    zip: string | null;
    zoning: string | null;
    landSize: number | null;
    buildingSize: number | null;
    lotCoverage: number | null;
    totalAssessment: number | null;
    ownerName: string | null;
    ownershipType: LeadOwnershipType | null;
    ownerAddress: string | null;
    contactName: string | null;
    email: string | null;
    pipedriveCompanyId: number | null;
    phoneNumber: string | null;
    saleDate: Date | null;
    salePrice: number | null;
    status: string;
    labelId: number | null;
    locationGrade: string | null;
    propertyGrade: string | null;
    usableArea: number | null;
    notes: ILeadNote[];
    hasExcelAttachments: boolean;
    modifiedDate: Date;
    modifiedByUser: string | null;
    activityId: number | null;
}

export interface ILeadResponseModel {
    id: number;
    latitude: number;
    longitude: number;
    parcelId: string | null;
    address: string | null;
    city: string | null;
    state: string | null;
    zip: string | null;
    zoning: string | null;
    landSize: number | null;
    buildingSize: number | null;
    lotCoverage: number | null;
    totalAssessment: number | null;
    ownerName: string | null;
    ownershipType: LeadOwnershipType | null;
    ownerAddress: string | null;
    contactName: string | null;
    email: string | null;
    pipedriveCompanyId: number | null;
    phoneNumber: string | null;
    saleDate: string | null;
    salePrice: number | null;
    status: string;
    labelId: number | null;
    locationGrade: string | null;
    propertyGrade: string | null;
    usableArea: number | null;
    notes: ILeadNoteResponseModel[];
    hasExcelAttachments: boolean;
    modifiedDate: string;
    modifiedByUser: string | null;
    activityId: number | null;
}

export interface ILeadEditState {
    status: string;
    labelId: number | null;
    address: string | null;
    zoning: string | null;
    landSize: number | null;
    usableArea: number | null;
    buildingSize: number | null;
    lotCoverage: number | null;
    totalAssessment: number | null;
    ownerName: string | null;
    ownershipType: LeadOwnershipType | null;
    ownerAddress: string | null;
    saleDate: Date | null;
    salePrice: number | null;
    pipedriveCompanyName: string | null;
    contactName: string | null;
    email: string | null;
    phoneNumber: string | null;
    isSetReminder: boolean;
    activityId: number | null;
    activityDueDate: Date | null;
    activitySubject: string | null;
}

export class LeadEditState implements ILeadEditState {
    status: string = "OpenLead";
    labelId: number | null = null;
    address: string | null = null;
    zoning: string | null = null;
    landSize: number | null = null;
    usableArea: number | null = null;
    buildingSize: number | null = null;
    lotCoverage: number | null = null;
    totalAssessment: number | null = null;
    ownerName: string | null = null;
    ownershipType: LeadOwnershipType | null = null;
    ownerAddress: string | null = null;
    saleDate: Date | null = null;
    salePrice: number | null = null;
    pipedriveCompanyName: string | null = null;
    contactName: string | null = null;
    email: string | null = null;
    phoneNumber: string | null = null;
    isSetReminder: boolean = false;
    activityId: number | null = null;
    activityDueDate: Date | null = null;
    activitySubject: string | null = null;

    static empty(): LeadEditState {
        return new LeadEditState();
    }
}

export interface ILeadCreateState {
    status: string;
    labelId: number | null;
    address: string | null;
    ownerName: string | null;
    ownershipType: LeadOwnershipType | null;
    zoning: string | null;
    landSize: number | null;
    buildingSize: number | null;
    lotCoverage: number | null;
    totalAssessment: number | null;
    ownerAddress: string | null;
    pipedriveCompanyName: string | null;
    contactName: string | null;
    email: string | null;
    phoneNumber: string | null;
    note: string | null;
}

export class LeadCreateState implements ILeadCreateState {
    status: string = "OpenLead";
    labelId: number | null = null;
    address: string | null = null;
    ownerName: string | null = null;
    ownershipType: LeadOwnershipType | null = null;
    zoning: string | null = null;
    landSize: number | null = null;
    buildingSize: number | null = null;
    lotCoverage: number | null = null;
    totalAssessment: number | null = null;
    ownerAddress: string | null = null;
    pipedriveCompanyName: string | null = null;
    contactName: string | null = null;
    email: string | null = null;
    phoneNumber: string | null = null;
    note: string | null = null;

    static empty(): LeadCreateState {
        return new LeadCreateState();
    }
}

export enum LeadStatus {
    OpenLead = "OpenLead",
    ActiveConversations = "ActiveConversations",
    OIPass = "OIPass",
    SellerPass = "SellerPass",
}

export enum LeadOwnershipType {
    Government = "Government",
    Individual = "Individual",
    Investor = "Investor",
    NonProfit = "NonProfit",
    OtherUnclassified = "OtherUnclassified",
    ShellCompany = "ShellCompany",
    Trust = "Trust",
    User = "User",
}
